import { createSelector } from "reselect";

import { initialState } from "containers/Shared/App/reducer";

const selectGlobal = (state) => state.global || initialState;
const selectRouter = (state) => state.router;

const selectLocation = () =>
  createSelector(selectRouter, (routerState) => routerState.location);

const selectEnterprise = () =>
  createSelector(selectGlobal, (globalState) => globalState.data?.enterprise);

const selectEnterprisePrivacyMessage = () =>
  createSelector(
    selectGlobal,
    (globalState) => globalState.data.enterprise?.privacy_statement,
  );

const selectPermissions = () =>
  createSelector(selectGlobal, (globalState) => globalState.data?.permissions);

const selectToken = () =>
  createSelector(selectGlobal, (globalState) => globalState.token);

const selectUserPolicyGroup = () =>
  createSelector(selectGlobal, (globalState) => globalState.data?.policy_group);

const selectUser = () =>
  createSelector(selectGlobal, (globalState) => globalState.data);

const selectIsFetchingUserData = () =>
  createSelector(selectGlobal, (globalState) => globalState.isFetchingUserData);

const selectFetchUserDataError = () =>
  createSelector(selectGlobal, (globalState) => globalState.fetchUserDataError);

const selectCustomText = () =>
  createSelector(selectGlobal, (globalState) => {
    const customTexts = globalState?.data?.enterprise?.custom_text;
    if (customTexts) {
      const flattenedCustomTexts = customTexts?.plural;
      for (const [key, value] of Object.entries(flattenedCustomTexts)) {
        customTexts[`${key}_p`] = value;
      }
    }
    return customTexts;
  });

export {
  selectGlobal,
  selectRouter,
  selectLocation,
  selectEnterprise,
  selectToken,
  selectUserPolicyGroup,
  selectUser,
  selectIsFetchingUserData,
  selectFetchUserDataError,
  selectCustomText,
  selectPermissions,
  selectEnterprisePrivacyMessage,
};
